/* global $ */

class DmcImage {
  constructor($container) {
    this.$window = $(window);
    this.$container = $container;
    this.$front = $container.find('.DmcImage__front');
    this.$back = $container.find('.DmcImage__back');

    this.isInvert = false;

    this.mediaQuery = window.matchMedia('(max-width: 600px)');

    this.$container.on('click', () => {
      console.log(this.mediaQuery.matches);
      if (this.mediaQuery.matches) {
        if (this.isInvert) {
          this.isInvert = false;
          this.$container.removeClass('is-invert');
        } else {
          this.isInvert = true;
          this.$container.addClass('is-invert');
        }
      }
    });

    this.$window.on('resize.dmcImage', () => {
      this.onWindowResize();
    });
  }

  onWindowResize() {
    if (!this.mediaQuery.matches) {
      if (this.isInvert) {
        this.isInvert = false;
        this.$container.removeClass('is-invert');
      }
    }
  }

  destroy() {
    this.$window.off('.dmcImage');
  }
}

export default DmcImage;
